/* @jsx */
import { css } from '@emotion/core';
import styled from '@emotion/styled';

export const innerCenteredRadioButtonContainerStyle = css`
  background-color: #748499;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
`;

export const RadioButtonContainer = styled.div<{ checked: boolean }>`
  border: 1px dashed #acb5c2;
  height: 38px;
  width: 38px;
  padding: 3px;
  border-color: ${(props) => (props.checked ? '#acb5c2' : '#fff')};
  &:hover {
    border-color: #acb5c2;
  }
`;

export interface RadioButtonProps {
  checked: boolean;
  children?: React.ReactNode;
}

//
// Radio button Components
//

/* @ngInject */
export function SquareCentered(props: RadioButtonProps) {
  return (
    <RadioButtonContainer checked={props.checked}>
      <div css={innerCenteredRadioButtonContainerStyle} className='condensed font-weight-bolder text-sm'>
        {props.children}
      </div>
    </RadioButtonContainer>
  );
}

/* @ngInject */
export function CircleCentered(props: RadioButtonProps) {
  return (
    <RadioButtonContainer checked={props.checked} className='rounded-circle'>
      <div
        css={css`
          ${innerCenteredRadioButtonContainerStyle};
        `}
        className='condensed text-sm font-weight-bolder rounded-circle'
      >
        {props.children}
      </div>
    </RadioButtonContainer>
  );
}
